// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuickJournalCyberpunkRain__rain___nsyV3 {
    position: absolute;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
}

.QuickJournalCyberpunkRain__drop___IgFjS {
    position: absolute;
    width: 1px;
    height: 25px;
    background: linear-gradient(transparent, rgba(102, 223, 245, 0.48));
    opacity: 0;
    transform-origin: bottom;
    animation: QuickJournalCyberpunkRain__neonRainFall___rwX8F 8s linear infinite;
}

.QuickJournalCyberpunkRain__drop___IgFjS:nth-child(even) {
    background: linear-gradient(transparent, rgba(239, 111, 200, 0.38));
}

@keyframes QuickJournalCyberpunkRain__neonRainFall___rwX8F {
    0%, 68% {
        opacity: 0;
        transform: translate3d(7px, -65px, 0) rotate(9deg) scaleY(0.7);
    }
    73% {
        opacity: 0.26;
    }
    82% {
        opacity: 0.2;
        transform: translate3d(0, 0, 0) rotate(9deg) scaleY(1);
    }
    85%, 100% {
        opacity: 0;
        transform: translate3d(-2px, 12px, 0) rotate(9deg) scaleY(0.3);
    }
}

/* Fill the air beneath the chevron independently of the pavement mask. */
.QuickJournalCyberpunkRain__bokeh___ih5NZ {
    position: absolute;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(76, 218, 239, 0.36), transparent 70%);
    filter: blur(5px);
    opacity: 0.28;
    animation: QuickJournalCyberpunkRain__neonBokehDrift___fL0te 13s ease-in-out infinite alternate;
}

.QuickJournalCyberpunkRain__bokeh___ih5NZ:nth-child(2) {
    width: 30px;
    height: 30px;
    background: radial-gradient(circle, rgba(226, 66, 169, 0.3), transparent 70%);
}

@keyframes QuickJournalCyberpunkRain__neonBokehDrift___fL0te {
    from {
        opacity: 0.22;
        transform: translate3d(-14px, 7px, 0) scale(0.85);
    }
    to {
        opacity: 0.62;
        transform: translate3d(18px, -9px, 0) scale(1.15);
    }
}

@media (prefers-reduced-motion: reduce) {
    .QuickJournalCyberpunkRain__drop___IgFjS,
    .QuickJournalCyberpunkRain__bokeh___ih5NZ {
        animation: none;
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rain": `QuickJournalCyberpunkRain__rain___nsyV3`,
	"drop": `QuickJournalCyberpunkRain__drop___IgFjS`,
	"neonRainFall": `QuickJournalCyberpunkRain__neonRainFall___rwX8F`,
	"bokeh": `QuickJournalCyberpunkRain__bokeh___ih5NZ`,
	"neonBokehDrift": `QuickJournalCyberpunkRain__neonBokehDrift___fL0te`
};
module.exports = ___CSS_LOADER_EXPORT___;
